import { Checkbox, Divider, Field, Form, Grid, Input, Select, Tab, Tree } from "@alifd/next";
import { BefGlobalContext, BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
const CheckboxGroup = Checkbox.Group;
const DepTypeRoleAssign = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, typeData, depId, ...otherProps } = props;
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const [dataSource, setDataSource] = useState({});
    const [tabFlag, setTabFlag] = useState(0);
    const sGlobal = useContext(BefGlobalContext);
    let [treeData, setTreeData] = useState({ datas: {} as any, isLoaded: {} as any, checkedKeys: {} as any });
    const setTreeDataEx = (data: any) => {
        treeData = data;
        setTreeData(data);
    }
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    const [roleCheckedList, setRoleCheckedList] = useState<any>([]);
    const [roleIndeterminate, setRoleIndeterminate] = useState(false);
    const [roleCheckAll, setRoleCheckAll] = useState(false);
    const [roleOptions, setRoleOptions] = useState<{ Roles: any, Permissions: any, DataAuthorities: any }>({ Roles: [], Permissions: [], DataAuthorities: [] });
    const [perCheckedList, setPerCheckedList] = useState<any>(null);
    const [perIndeterminate, setPerIndeterminate] = useState(false);
    const [perCheckAll, setPerCheckAll] = useState(false);
    const [perCheckedCount, setPerCheckedCount] = useState(0);
    const [dataCheckedList, setDataCheckedList] = useState<any>(null);
    const [dataIndeterminate, setDataIndeterminate] = useState(false);
    const [dataCheckAll, setDataCheckAll] = useState(false);
    const [dataCheckedCount, setDataCheckedCount] = useState(0);
    const getTreeNodeData = (type: string, idKey: string, data: any, checkedKeys: string[], prefix: string = "") => {
        const { Description, Selected } = data;
        let key = `${prefix}${data[idKey]}`;
        if (Selected == true) checkedKeys.push(key);
        let children = data[`${type}Roles`]?.map((val: any) => getTreeNodeData(type, idKey, val, checkedKeys, `${key}&`));
        return { key: key, label: Description, extraData: data, children: children };
    }

    const onTabChange = async (key: any) => {
        try {
            if (key == 'Role') setTabFlag(0);
            else if (key === 'Permission') setTabFlag(1);
            else setTabFlag(2);
            if (treeData.isLoaded[key] == true) return;
            let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeRole", { Action: "Get", Type: key, AppId: sGlobal.currentAppId, Id: depId, Data: { Id: typeData.Id } }) as any;
            let isLoaded = { ...treeData.isLoaded };
            isLoaded[key] = true;
            let _dataOptions = [] as any;
            let _selected = [] as any;
            if (key == 'Role') {
                if (result && result.length > 0) {
                    _dataOptions = result.map((item: any) => {
                        if (item.Selected)
                            _selected.push(item.Id);
                        return { label: item.Description, value: item.Id };
                    });
                    setRoleOptions({ ...roleOptions, Roles: _dataOptions });

                    if (_selected.length > 0) {
                        if (_selected.length == _dataOptions.length) {
                            setRoleIndeterminate(false);
                            setRoleCheckAll(true);
                        } else {
                            setRoleIndeterminate(true);
                            setRoleCheckAll(false);
                        }

                    } else {
                        setRoleIndeterminate(false);
                        setRoleCheckAll(false);
                    }

                    setRoleCheckedList(_selected);
                }

            }
            else if (key === 'Permission') {
                if (result.Permissions && result.Permissions.length > 0) {
                    let _total = 0;
                    let _snum = 0;
                    _dataOptions = result.Permissions.map((item: any) => {

                        let _pers = [];
                        let _perselected = [] as any;
                        if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                            _pers = item.PermissionRoles.map((it: any) => {
                                if (it.Selected) {
                                    _perselected.push(it.ID);
                                    _snum++;
                                }
                                _total++;
                                return { label: it.Description, value: it.ID };
                            })
                        }
                        _selected[item.ID] = _perselected;
                        return { Description: item.Description, Id: item.ID, PermissionRoles: _pers };
                    });
                    setPerCheckedList(_selected);
                    setRoleOptions({ ...roleOptions, Permissions: _dataOptions });
                    setPerCheckedCount(_total);
                    if (_snum == 0) {
                        setPerIndeterminate(false);
                        setPerCheckAll(false);
                    } else {
                        if (_snum == _total) {
                            setPerIndeterminate(false);
                            setPerCheckAll(true)
                        } else {
                            setPerIndeterminate(true);
                            setPerCheckAll(false)
                        }
                    }
                }

            } else {
                if (result.DataAuthorities && result.DataAuthorities.length > 0) {
                    let _total = 0;
                    let _snum = 0;
                    _dataOptions = result.DataAuthorities.map((item: any) => {

                        let _pers = [];
                        let _perselected = [] as any;
                        if (item.AuthorityRoles && item.AuthorityRoles.length > 0) {
                            _pers = item.AuthorityRoles.map((it: any) => {
                                if (it.Selected) {
                                    _perselected.push(it.ID);
                                    _snum++;
                                }
                                _total++;
                                return { label: it.Description, value: it.ID };
                            })
                        }
                        _selected[item.ID] = _perselected;
                        return { Description: item.Description, Id: item.ID, AuthorityRoles: _pers };
                    });
                    setDataCheckedList(_selected);
                    setRoleOptions({ ...roleOptions, DataAuthorities: _dataOptions });
                    setDataCheckedCount(_total);
                    if (_snum == 0) {
                        setDataIndeterminate(false);
                        setDataCheckAll(false);
                    } else {
                        if (_snum == _total) {
                            setDataIndeterminate(false);
                            setDataCheckAll(true)
                        } else {
                            setDataIndeterminate(true);
                            setDataCheckAll(false)
                        }
                    }
                }
            }
            setTreeDataEx({ ...treeData, datas: [], isLoaded: isLoaded, checkedKeys: [] });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, `用户权限配置：获取${key}数据`));
        }
    }

    const saveData = async () => {
        let _per = [] as any;
        if (perCheckedList) {
            for (let i in perCheckedList) {
                if (perCheckedList[i].length > 0) {
                    _per.push({ Id: i, Roles: perCheckedList[i] })
                }
            }
        } else _per = null;
        let _data = [] as any;
        if (dataCheckedList) {
            for (let i in dataCheckedList) {
                if (dataCheckedList[i].length > 0) {
                    _data.push({ Id: i, Roles: dataCheckedList[i] })
                }
            }
        } else _data = null;
        let data = {
            Role: roleCheckedList ?? null,
            Permission: _per ?? null,
            DataAuthority: _data ?? null
        };
        let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeRole", { Action: "Save", AppId: sGlobal.currentAppId, Id: depId, Data: { Id: typeData.Id }, Datas: data });
        return result;
    }
    const onRoleChange = (list: string | any[]) => {
        setRoleCheckedList(list);
        setRoleIndeterminate(!!list.length && list.length < roleOptions.Roles.length);
        setRoleCheckAll(list.length === roleOptions.Roles.length);
    };
    const onRoleCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        if (e.target.checked) {
            let _selected = [];
            if (roleOptions && roleOptions.Roles.length > 0) {
                _selected = roleOptions.Roles.map(((item: any) => {
                    return item.value;
                }));
            }
            setRoleCheckedList(_selected);
        } else {
            setRoleCheckedList([]);
        }

        setRoleIndeterminate(false);
        setRoleCheckAll(e.target.checked);
    };
    const onPerChange = (list: string | any[], id: any) => {
        let _data = { ...perCheckedList };
        _data[id] = list;
        setPerCheckedList(_data);
        let _selected = 0;
        for (let i in _data) {
            _selected += _data[i].length;
        }
        if (_selected == 0) {
            setPerIndeterminate(false);
            setPerCheckAll(false);
        } else {
            if (_selected == perCheckedCount) {
                setPerIndeterminate(false);
                setPerCheckAll(true);
            } else {
                setPerIndeterminate(true);
                setPerCheckAll(false);
            }

        }
    };
    const onPerCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        let _selected = [] as any;
        if (roleOptions && roleOptions.Permissions.length > 0) {
            roleOptions.Permissions.map(((item: any) => {
                let _se = [] as any;
                if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                    item.PermissionRoles.map((it: any) => {
                        _se.push(it.value);
                    });
                }
                if (e.target.checked)
                    _selected[item.Id] = _se;
                else _selected[item.Id] = [];
            }));
        }
        setPerCheckedList(_selected);
        setPerIndeterminate(false);
        setPerCheckAll(e.target.checked);
    };
    const onDataChange = (list: string | any[], id: any) => {
        let _data = { ...dataCheckedList };
        _data[id] = list;
        setDataCheckedList(_data);
        let _selected = 0;
        for (let i in _data) {
            _selected += _data[i].length;
        }
        if (_selected == 0) {
            setDataIndeterminate(false);
            setDataCheckAll(false);
        } else {
            if (_selected == dataCheckedCount) {
                setDataIndeterminate(false);
                setDataCheckAll(true);
            } else {
                setDataIndeterminate(true);
                setDataCheckAll(false);
            }

        }
    };
    const onDataCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        let _selected = [] as any;
        if (roleOptions && roleOptions.DataAuthorities.length > 0) {
            roleOptions.DataAuthorities.map(((item: any) => {
                let _se = [] as any;
                if (item.AuthorityRoles && item.AuthorityRoles.length > 0) {
                    item.AuthorityRoles.map((it: any) => {
                        _se.push(it.value);
                    });
                }
                if (e.target.checked)
                    _selected[item.Id] = _se;
                else _selected[item.Id] = [];
            }));
        }
        setDataCheckedList(_selected);
        setDataIndeterminate(false);
        setDataCheckAll(e.target.checked);
    };
    const extraContent = (
        <>  {
            tabFlag == 0 && <div className="display-flex justify-end">
                <Checkbox className="custom-form-control" indeterminate={roleIndeterminate} onChange={onRoleCheckAllChange} checked={roleCheckAll}>
                    Check all
                </Checkbox>
            </div>
        }
            {
                tabFlag == 1 && <div className="display-flex justify-end">
                    <Checkbox className="custom-form-control" indeterminate={perIndeterminate} onChange={onPerCheckAllChange} checked={perCheckAll}>
                        Check all
                    </Checkbox></div>
            }
            {
                tabFlag == 2 && <div className="display-flex justify-end">
                    <Checkbox className="custom-form-control" indeterminate={dataIndeterminate} onChange={onDataCheckAllChange} checked={dataCheckAll}>
                        Check all
                    </Checkbox></div>
            }
        </>

    )
    useEffect(() => {
        if (typeData) {

            fieldRef.current.setValue("id", typeData.Id);
            fieldRef.current.setValue("name", typeData.Name);
            onTabChange("Role");
            setTabFlag(0);
        }
    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        proxy.save = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate(async (errors: any, values: any) => {
                        try {
                            if (errors != null) return;
                            let result = await saveData();
                            resolve(result);
                        } catch (error) {
                            reject(error);
                        }
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, [rpcAssembly, rpcModule, treeData, roleCheckedList, perCheckedList, dataCheckedList]);
    return (
        <Form style={{ minHeight: "400px" }} field={fieldRef.current} className="bef-custom-user">
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="级别Id" name="id" className="custom-form-control">
                        <Input disabled />
                    </Form.Item>

                </Grid.Col>
                <Grid.Col>
                    <Form.Item required label="级别名称" name="name" className="custom-form-control">
                        <Input disabled />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <div className="tab-div dialog-tab">
                        <Tab lazyLoad={false} onChange={onTabChange} extra={extraContent}>
                            <Tab.Item title="Role" key="Role">
                                <div className="bef-user-check-group">
                                    <div className="check-con sp">
                                        <Checkbox.Group className="custom-form-control flex-1" value={roleCheckedList} onChange={onRoleChange} >
                                            {roleOptions.Roles.map((item: any) => {
                                                return <>
                                                    <div style={{ padding: '8px', display: 'flex' }}>
                                                        <span className="per-desc"> {item.value}
                                                            <span style={{ marginLeft: '16px' }}>{item.label} </span></span>
                                                        <Checkbox value={item.value}> </Checkbox>
                                                    </div>
                                                </>
                                            })}
                                        </Checkbox.Group>
                                    </div>
                                </div>
                            </Tab.Item>
                            <Tab.Item title="Permission" key="Permission">
                                <div className="bef-user-check-group">
                                    <div className="check-con">
                                        <ul>
                                            {roleOptions.Permissions.map((pers: any) => <>
                                                <li> <span className="per-desc"> {pers.Description}</span>
                                                    <CheckboxGroup className="flex-1 custom-form-control" dataSource={pers.PermissionRoles} value={perCheckedList[pers.Id]}
                                                        onChange={(val) => { onPerChange(val, pers.Id) }} />
                                                </li>
                                            </>)
                                            }
                                        </ul>
                                    </div>

                                </div>

                            </Tab.Item>
                            <Tab.Item title="DataAuthority" key="DataAuthority">
                                <div className="bef-user-check-group">
                                    <div className="check-con">
                                        <ul>
                                            {roleOptions.DataAuthorities.map((pers: any) => <>
                                                <li> <span className="per-desc"> {pers.Description}</span>
                                                    <CheckboxGroup className="flex-1 custom-form-control" dataSource={pers.AuthorityRoles} value={dataCheckedList[pers.Id]}
                                                        onChange={(val) => { onDataChange(val, pers.Id) }} />
                                                </li>
                                            </>)
                                            }</ul></div></div>
                            </Tab.Item>
                        </Tab>
                    </div>

                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});

export default DepTypeRoleAssign;